import { DefaultState, TableFilters } from 'store/reducers/types';

export const READ_ASSIGNMENT_REPORT_FILTERS_REQUEST = 'READ_ASSIGNMENT_REPORT_FILTERS_REQUEST';
export const READ_ASSIGNMENT_REPORT_FILTERS_SUCCESS = 'READ_ASSIGNMENT_REPORT_FILTERS_SUCCESS';
export const READ_ASSIGNMENT_REPORT_FILTERS_FAILURE = 'READ_ASSIGNMENT_REPORT_FILTERS_FAILURE';

export type AssignmentReportFiltersState = DefaultState & {
  contents?: TableFilters;
};

interface ReadAssignmentReportFiltersRequest {
  type: typeof READ_ASSIGNMENT_REPORT_FILTERS_REQUEST;
};

interface ReadAssignmentReportFiltersSuccess {
  type: typeof READ_ASSIGNMENT_REPORT_FILTERS_SUCCESS,
  contents: TableFilters;
};

interface ReadAssignmentReportFiltersFailure {
  type: typeof READ_ASSIGNMENT_REPORT_FILTERS_FAILURE;
};

export type AssignmentReportFiltersActionTypes = ReadAssignmentReportFiltersRequest | ReadAssignmentReportFiltersSuccess | ReadAssignmentReportFiltersFailure;